module.exports = __webpack_public_path__ + "static/media/phone-screen@3x.9fd650a3.png";